import { createContext } from "react";
export default createContext({
    currentId: 0,
    videoDuration: 0,
    bufferAction: false,
    pause: false,
    next: function() {}
});
